<template>
  <div
    v-for="(item, index) in data"
    :key="index"
    class="member_details__content"
  >
    <div class="member_details__history">
      <router-link :to="routeOptions(item)">
        <div class="member_details__history-heading">
          <div class="member_details__history-heading-row">
            <div class="member_details__history-heading-row-item">
              <strong class="member_details__history-type">{{
                $t(`shafts.condition.${item.activity_group}`)
              }}</strong>
              <span class="member_details__history-id">
                &nbsp;#{{ item.activity_group_detail.short_id }}
              </span>
            </div>
            <div class="member_details__history-heading-row-item">
              <div
                v-if="item.activity_group !== 'job'"
                class="member_details__history-heading-right"
              >
                <div
                  :class="`typo-tiny member_details__history-condition member_details__history-condition--${item.overall_condition_rating}`"
                >
                  {{ item.overall_condition_rating }}
                </div>
                <div class="status">
                  <component
                    :is="statusIcon[item.activity_group_detail.status]"
                  />
                </div>
                <div
                  v-if="item.activity_group === 'job'"
                  class="typo-tiny"
                >
                  {{ item.activity_group_detail.status }}
                </div>
              </div>
            </div>
          </div>
          <div class="member_details__history-heading-row">
            <div
              class="member_details__history-heading-row-item typo-tiny member_details__history-date"
            >
              {{ formatDate(item.activity_group_detail.date) }}
            </div>
            <div
              v-if="item.activity_group === 'job'"
              class="member_details__history-heading-row-item typo-tiny"
            >
              <!-- TODO: check what info is needed here -->
            </div>
          </div>
        </div>
      </router-link>

      <DetmechAccordion
        v-if="item.deterioration_mechanism_ratings"
        :detmechs="item.deterioration_mechanism_ratings"
        :isOpen="index === 0"
        :title="$t('shafts.condition.deterioration_mechanisms')"
      />
    </div>
  </div>
</template>

<script setup>
import { formatDate } from '@/functions/date_format_helpers';

import DetmechAccordion from '@/components/shafts/condition/detmech_accordion.vue';

import CircleCheckmark16Svg from '@/images/circle-checkmark-16.svg';
import ViewFinderDot16Svg from '@/images/viewfinder-dot-16.svg';
import CircleDot16Svg from '@/images/circle-dotted-16.svg';

defineProps({
  data: { type: Array, required: true },
});

/**
 * Status icons
 */
const statusIcon = {
  approved: CircleCheckmark16Svg,
  in_progress: ViewFinderDot16Svg,
  awaiting_approval: CircleDot16Svg,
};

/**
 * Returns the correct scope for the router
 */
function setRouteScope(status) {
  switch (status) {
    case 'approved':
      return 'approved_inspections';
    case 'transferred_to_planner':
      return 'jobs';
    case 'completed':
      return 'completed_jobs';
    default:
      return 'inspections';
  }
}

/**
 * Returns the correct data for the router
 */
function routeOptions(data) {
  switch (data.type) {
    case 'shafts_issue':
      return {
        name: 'shaftInspection',
        params: {
          inspectionId: data.activity_group_detail.id,
          scope: setRouteScope(data.activity_group_detail.status),
        },
      };
    default:
      return {
        name: 'shaftJob',
        params: {
          jobId: data.activity_group_detail.id,
          scope: setRouteScope(data.activity_group_detail.status),
        },
      };
  }
}
</script>

<style lang="scss" scoped>
@import '@/stylesheets/global';

.member_details__history {
  margin-top: bu(2);
  background: map-get($background-color, lighter);
  border-radius: map-get($border-radius, heavy);
  padding: bu(1.5);

  &-heading-right {
    display: flex;
    align-items: center;
  }

  &-heading-row {
    display: flex;
    justify-content: space-between;

    &:not(:first-child) {
      margin-top: bu(1);
    }
  }

  &-condition {
    align-items: center;
    background-color: map-get($background-color, lightest);
    border-radius: map-get($border-radius, light);
    color: map-get($foreground-color, light);
    display: flex;
    font-weight: 500;
    height: bu(2.5);
    justify-content: center;
    width: bu(2.5);
    margin-right: bu(1);

    @each $rating, $color in $condition-rating-color {
      &--#{$rating} {
        background-color: map-get($color, default);
      }
    }
  }
}
</style>
